import { render, staticRenderFns } from "./m-trim-setting.vue?vue&type=template&id=3b870234&scoped=true&"
import script from "./m-trim-setting.vue?vue&type=script&lang=ts&setup=true&"
export * from "./m-trim-setting.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./m-trim-setting.vue?vue&type=style&index=0&id=3b870234&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b870234",
  null
  
)

export default component.exports